import React from 'react';
import { BillingPeriod } from '../types';

interface BillingPeriodSelectorProperties {
  selected: BillingPeriod;
  onChange: (period: BillingPeriod) => void;
  disabled3Monthly?: boolean;
  disabledMonthly?: boolean;
  disabledWarning?: string;
}

const BillingPeriodSelector: React.FC<BillingPeriodSelectorProperties> = ({
  selected,
  onChange,
  disabled3Monthly = false,
  disabledMonthly = false,
  disabledWarning,
}) => {
  const options = [
    {
      value: 'month' as BillingPeriod,
      label: 'Monthly',
      description: 'Pay monthly',
      disabled: disabledMonthly,
    },
    {
      value: '3month' as BillingPeriod,
      label: '3-month',
      description: '20% OFF!',
      disabled: disabled3Monthly,
      badge: 'POPULAR',
    },
    {
      value: 'year' as BillingPeriod,
      label: 'Annual',
      description: '5 months free!',
      disabled: false,
      badge: 'SAVE 45%',
    },
  ];

  return (
    <div className="w-full max-w-md mx-auto">
      <div className="grid grid-cols-3 gap-2 p-1 bg-gray-100 rounded-lg">
        {options.map((option) => (
          <button
            key={option.value}
            onClick={() => !option.disabled && onChange(option.value)}
            disabled={option.disabled}
            title={option.disabled ? disabledWarning : ''}
            className={`
              relative px-3 py-3 rounded-md text-sm font-medium transition-all duration-200
              ${
                selected === option.value
                  ? 'bg-tttDefault text-white shadow-sm'
                  : option.disabled
                  ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                  : 'bg-white text-gray-700 hover:bg-gray-50 cursor-pointer'
              }
            `}
          >
            {option.badge && (
              <div
                className={`
                  absolute -top-1 -right-1 px-1.5 py-0.5 text-xs font-bold rounded-full transform rotate-12
                  ${
                    selected === option.value
                      ? 'bg-white text-tttDefault'
                      : 'bg-tttDefault text-white'
                  }
                `}
              >
                {option.badge}
              </div>
            )}
            <div className="text-center">
              <div className="font-semibold">{option.label}</div>
              <div
                className={`text-xs mt-1 ${
                  selected === option.value ? 'text-white/80' : 'text-gray-500'
                }`}
              >
                {option.description}
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default BillingPeriodSelector;
